<template>
  <div>
    <v-dialog persistent :value="addModal" @keydown.esc="closeModal()" width="700">
      <v-card>
        <loading-block class="pt-8" v-if="!loaded"></loading-block>
        <div v-else>
            <v-card-title class="pb-0 mb-0">Assign Location Category</v-card-title>
            <v-card-text>
                <v-checkbox
                    v-for="(category, index) in categoryList" :key="index"
                    color="primary"
                    :label="category.name"
                    :value="category.id"
                    v-model="form.location_category_id"
                    hide-details
                ></v-checkbox>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                depressed
                @click="closeModal()"
                color="white"
                :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
                style="text-transform: capitalize;"
                >Cancel</v-btn>
                <v-btn
                @click="add()"
                color="white"
                :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0 primary' : 'ml-0 primary'"
                style="text-transform: capitalize;"
                >Assign</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { LocationCategoryAPI } from '@/clients/location/location.category.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
    LoadingBlock
  },
  data() {
    return {
      loaded: false,
      form: {
          location_category_id: []
      }
    }
  },
  async mounted() {
    try {
        await this.va_locationCategoryList(this.editObj.location_id)
        await this.va_locationCategoryAssignedList(this.editObj.id)
        this.form.location_category_id = this.assignList.map(item => {
            return item.id
        })
        this.loaded = true
    } catch (err) {
        this.loaded = true
    }
  },
  computed: {
      ...mapGetters({
          categoryList: 'locationcategory/list',
          assignList: 'locationcategory/assignList',
          editObj: 'locationproduct/editObj',
          addModal: 'locationproduct/assignCatPop'
      })
  },
  methods: {
    /**
     * Close add  popup
     */
    async closeModal() {
        this.setAssignCatPopup(false)
    },
    async add() {
      try {
        this.spinner(true)
        let data = {
          location_product_id: this.editObj.id,
          location_category_id: this.form.location_category_id
        }
        await LocationCategoryAPI.syncFeaturedCategory(data)
        this.spinner(false)
        this.closeModal()
      } catch (err) {
        this.spinner(false)
      }
    },
    ...mapActions({
        setAssignCatPopup: 'locationproduct/setAssignCatPop',
        va_locationCategoryList: 'locationcategory/setList',
        va_locationCategoryAssignedList: 'locationcategory/assignedList'
    })
  }
}
</script>
